"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEditorialDebug = exports.debugQueryParam = void 0;
var _presentationUtils = require("@ori/presentation-utils");
const debugQueryParam = exports.debugQueryParam = 'debugEditorialPage';
const getEditorialDebug = ()=>{
    const paramValue = (0, _presentationUtils.getClientQueryParam)(debugQueryParam);
    return paramValue === 'true';
};
exports.getEditorialDebug = getEditorialDebug;
